<style scoped>
.Item {
  overflow: hidden;
  border-radius: 4px;
  width: 100%;

  background: #f5f5f5;
}

.Content {
  padding: 20px;
}

img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  line-height: 0;
  display: block;
}
</style>

<template>
  <div data-color="dark" class="js-header-panel ">
    <div
      class="c-page c-blog u-pad-x-w3of12 u-pad-x-w1of12@sm u-pad-t-xxl u-pad-t-ultra@sm "
    >
      <section>
        <h1 class="mb-24">Vue Masonry Wall Images</h1>
        <vue-masonry-wall :items="post" :options="options">
          <template v-slot:default="{ item }">
            <div class="Item">
              <img :src="item.image" />

              <!--<div class="Content">
						<h5 class="text-ellipsis-1l">{{item.title}}</h5>
						<p class="text-ellipsis-2l">{{item.content}}</p>
					</div>
					-->
            </div>
          </template>
        </vue-masonry-wall>
      </section>
    </div>
    <app-footer
      :globalContent="globalContent"
      :adminContent="adminContent"
    ></app-footer>
  </div>
</template>
<script>
import AppFooter from "../app-footer/index.vue";
import AppScrollObject from "../app-scroll-object/index.vue";
import AppSlicedText from "../app-sliced-text/index.vue";
import VueMasonryWall from "vue-masonry-wall";
export default {
  components: {
    "app-sliced-text": AppSlicedText,
    "app-footer": AppFooter,
    "app-scroll-object": AppScrollObject,
    VueMasonryWall,
  },
  props: {
    adminContent: {
      type: Object,
      default: function() {}
    },
    globalContent: {
      type: Object,
      default: function() {}
    },
    headerPageSize: {
      type: Array,
      default: function() {}
    }
  },
  computed: {
    content: function() {
      return this.adminContent.en.pages.contact;
    },
    computedPosts: function() {
      let categories = this.$route.params.cat;
      if (!categories) categories = "appetizers";
      console.log(this.items[categories]);
      return this.items[categories];
    },
    myStylesTransform2() {
      return {
        transform:
          "translateX(" +
          this.headerPageSize[2] +
          "px) translateY(" +
          this.headerPageSize[3] +
          "px) scale(" +
          this.headerPageSize[4] +
          ")",
      };
    },
    myStylesWidthHeight() {
      return {
        width: this.headerPageSize[0] + "px",
        height: this.headerPageSize[1] + "px",
      };
    },
  },
  created: function() {
    (this.post = this.computedPosts),
      (this.onResize = this.onResize.bind(this)),
      this.eventHub.$on("resize", this.onResize);
  },
  destroyed: function() {
    this.eventHub.$off("resize", this.onResize);
  },
  mounted: function() {
    this.eventHub.$emit("page:ready"), this.onResize();
  },
  data: function() {
    return {
      options: {
        width: 300,
        padding: {
          2: 8,
          default: 12,
        },
      },
      items: {
        appetizers: [
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Appetizers/_POH9943.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Appetizers/0195.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Appetizers/0197.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Appetizers/Baklava-Brie-new.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Appetizers/Beef-Baklava.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Appetizers/Bruschetta-new.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Appetizers/Fajitas-Rolls.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Appetizers/Feuillette-Goat-Spinach-cheese.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Appetizers/Hommos-trio.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Appetizers/Mille-feuille-saumon.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Appetizers/Mini-quiches.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Appetizers/Quiches-Mini-Mixed.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Appetizers/Quiches-Mini-Mixed2.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Appetizers/Salameh-Traiteur-by-Jose-Daou-4961.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Appetizers/WhatsApp Image 2023-07-01 at 11.37.53 AM (14).jpeg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Appetizers/Salameh-Traiteur-by-Jose-Daou-4969.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Appetizers/Salameh-Traiteur-by-Jose-Daou-4973.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Appetizers/Salameh-Traiteur-by-Jose-Daou-4999.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Appetizers/Salameh-Traiteur-by-Jose-Daou-5185.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Appetizers/Salameh-Traiteur-by-Jose-Daou-5229.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Appetizers/Salameh-Traiteur-by-Jose-Daou-5243.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Appetizers/Shawarmaلقم.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Appetizers/Vol-au-Vent-Mixed.jpg"
          },
        ],
        dessert: [
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Dessert/_POH0022.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Dessert/dessert1.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Dessert/dessert2.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Dessert/dessert3.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Dessert/dessert4.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Dessert/dessert5.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Dessert/dessert6.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Dessert/dessert7.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Dessert/Mini-Mousse-.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Dessert/Mini-Soire.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Dessert/Mohallabiyeh.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Dessert/Tart Fraise.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Desset/Tart-Strawberry.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Dessert/WhatsApp-Image-2023-07-25-at-09.11.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Dessert/WhatsApp-Image-2023-08-08-at-10.38.jpg"
          },
        ],
        foodsetup: [
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Food-Setup/setup1.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Food-Setup/setup2.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Food-Setup/setup3.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Food-Setup/setup4.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Food-Setup/setup5.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Food-Setup/setup6.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Food-Setup/setup7.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Food-Setup/setup8.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Food-Setup/setup9.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Food-Setup/setup10.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Food-Setup/setup11.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Food-Setup/setup12.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Food-Setup/setup13.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Food-Setup/setup14.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Food-Setup/setup15.jpg"
          },
        ],
        maincourse: [
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Main-Course/_AKP3002.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Main-Course/Beef-Alouette-with-Veg.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Main-Course/Gigot-with-Veg.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Main-Course/Gigot-with-Vegetables-.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Main-Course/Grilled-Chicken-stuffed-with-Cheese-&-Ham-.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Main-Course/Hauts-de-cuisse.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Main-Course/main-course1.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Main-Course/main-course2.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Main-Course/main-course3.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Main-Course/main-course4.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Main-Course/main-course5.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Main-Course/main-course6.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Main-Course/Noodles-Veggie.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Main-Course/Paëlla.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Main-Course/Paiella.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Main-Course/Roulade Poulet new rechaud.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Main-Course/Roulade-de-Poulet-new-rechaud.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Main-Course/Roulade-new.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Main-Course/Roulade-Poulet-new-rechaud.jpg"
          },
        ],
        salads: [
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Salads/Crabe Frais Salade.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Salads/Crabe-Frais-Salade-.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Salads/Crevette-exotique-salade-.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Salads/Kale-et-Poulet--Salade-.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Salads/Legumes-Grillé,-Mozzarella-Salade-.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Salads/Orzo-aux-Legumes-et-feta.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Salads/Paysanne-Salade-.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Salads/Quinoa-Fruits-Secs-.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Salads/Quinoa-Shrimp-et-Saumon-.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Salads/Rocca-bresaola.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Salads/Rocca-Bresaola-.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Salads/Salade4.jpg.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Salads/Salade5.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Salads/Salade2.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Salads/Salameh-Traiteur-by-Jose-Daou-4900.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Salads/Salameh-Traiteur-by-Jose-Daou-4911.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Salads/Salameh-Traiteur-by-Jose-Daou-5045.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Salads/Salameh-Traiteur-by-Jose-Daou-5056.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Salads/Salameh-Traiteur-by-Jose-Daou-5070.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Salads/Salameh-Traiteur-by-Jose-Daou-5074.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Salads/Salameh-Traiteur-by-Jose-Daou-5075.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Salads/Salameh-Traiteur-by-Jose-Daou-5089.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Salads/Salameh-Traiteur-by-Jose-Daou-5158.jpg"
          },
          {
            title: "",
            content: "",
            image:
              "/static/ProductsImages/Salads/Salameh-Traiteur-by-Jose-Daou-5165.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Salads/Sweet-Potato-Salade-.jpg"
          },
        ],
        setup: [
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/setup/_POH0135.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/setup/_POH0140.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/setup/IMG-20220920-WA0011.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/setup/MAL08002.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/setup/bellevu.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/setup/WOOD-Napkins-.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/setup/Wood-new.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/setup/WOOD-Sous-Plat-.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/setup/WOOD-Theme-.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/setup/WOOD-X.jpg"
          }
        ],
        stations: [
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Stations/_POH0072.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Stations/5.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Stations/BARBECUE.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Stations/HANGED-SALMON.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Stations/Kebbe.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Stations/Manti.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Stations/Manti-Station-I.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Stations/Mexican-Station-new-.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Stations/Mini-Shawarma-Mixed-.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Stations/Shawarma-Station.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Stations/station1.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Stations/Station2.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Stations/station3.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Stations/station4.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Stations/WHM03350.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Stations/WHM03393.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Stations/WHM03394.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Stations/WHM03397.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Stations/WHM03399.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Stations/WHM03404.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Stations/WHM03418.jpg"
          },
          {
            title: "",
            content: "",
            image: "/static/ProductsImages/Stations/WHM03419.jpg"
          }
        ]
      }
    };
  },
  methods: {
    onResize: function() {},
    _getGoogleMapUrl: function(t) {
      return "https://drive.google.com/open?id=1L0EorG9WxDMEQx055BjFMkFD3yp_E8mE&usp=sharing";
      //return this.GOOGLE_API_URL.replace(":address", encodeURIComponent(t.replace("<br />", " ").replace("\n", "")))
    },
  },
};
</script>
